"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpirationPolicyService = void 0;
const axios_1 = require("axios");
const _1 = require(".");
class ExpirationPolicyService {
    async load(key, orgId, environment = null) {
        let expirationPolicy = null;
        try {
            const response = await axios_1.default.get(`${this.seApiEndpoint(environment)}/v3/eligibility/expiration_policies/policy/${key}/${orgId}`);
            expirationPolicy = new _1.ExpirationPolicy(response.data.result);
        }
        catch (err) {
            expirationPolicy = null;
        }
        return expirationPolicy;
    }
    seApiEndpoint(environment) {
        if (!environment) {
            environment = process.env.NODE_ENV;
        }
        switch (environment.toLowerCase()) {
            case 'production':
                return 'https://api.sportngin.com';
            case 'staging':
                return 'https://api.stage.ngin-staging.com';
            case 'development':
            default:
                return 'https://api.sportngin.com.dev';
        }
    }
}
exports.ExpirationPolicyService = ExpirationPolicyService;
